import {calculateAge, getYearFromEffectiveDate, parseId} from '../../helpers'
import {INIT_FORM_MEMBERS} from '../../helpers/consts'
import {IResStates} from '../../types/statesEU'
import {IForm, IPerson} from '../oneAddQuote/oneQuoteTypes'
import {TFormAllValues} from '../policies/policiesTypes'
import {getStateEUById, getStateEUParseIdById} from '../shared/utils'

export const parseFloatOrZero = (val: string | number | undefined | null): number => {
  const n = parseFloat(String(val).replace(/,/g, ''))
  return isNaN(n) ? 0 : n
}

export function isApplicant(value: string | boolean): boolean {
  return value === true || value === 'true'
}

export function sumarIngresosTotales(members: any[]): number {
  return members.reduce((total, member) => {
    const ingreso1 = parseFloat(member.annualIncome1 || '0') || 0
    const ingreso2 = parseFloat(member.annualIncome2 || '0') || 0
    const ingreso3 = parseFloat(member.annualIncome3 || '0') || 0

    return total + ingreso1 + ingreso2 + ingreso3
  }, 0)
}

export const mapFormQuoteToQuoteData = (
  formValues: TFormAllValues,
  dataStates: IResStates | undefined
): IForm => {
  const allMembersAndHolder = [formValues.holder, ...formValues.policyMembers]
  const allMembers = [...formValues.policyMembers]
  const holderMember = formValues.holder

  const holderAge = holderMember.age ?? calculateAge(holderMember.dateBirth) ?? 0
  const personOne: any = {
    age: holderAge || '',
    dob: holderMember.dateBirth,
    gender: holderMember.gender,
    isPregnant: holderMember.isPregnant,
    pregnantWith: '',
    isParent: false,
    usesTobacco: holderMember.usesTobacco,
    lastTobaccoUseDate: '',
    hasMec: holderAge < 19 ? true : (holderMember.hasMec === true || holderMember.hasMec === 'true'),
    aptcEligible: true,
    utilizationLevel: '',
    relationship: '', // holderMember.relationship || ''
    doesNotCohabitate: '',
    currentEnrollment: holderMember.currentEnrollment ?? null,
  }

  const people: IPerson[] = allMembers
    ?.filter((member) => member.rol !== 'HOLDER') // excluye al HOLDER
    ?.map((member, index) => {
      const age = member.age ?? calculateAge(member.dateBirth) ?? 0
      return {
      age: age || '',
      dob: member.dateBirth,
      gender: member.gender,
      isPregnant: member.isPregnant,
      pregnantWith: '',
      isParent: false,
      usesTobacco: member.usesTobacco,
      lastTobaccoUseDate: '',
      hasMec: age < 19 ? true : (member.hasMec === true || member.hasMec === 'true'),
      aptcEligible: true,
      utilizationLevel: '',
      relationship: '', // member.relationship || ''
      doesNotCohabitate: '',
      currentEnrollment: member.currentEnrollment ?? null,
    }
  })
  // console.log('personOne', personOne)
  // console.log('people', people)
  const householdIncome = sumarIngresosTotales(allMembersAndHolder)

  // console.log('allMembersAndHolder', allMembersAndHolder)
  console.log('allMembers.length', allMembers.length + 1)

  return {
    queryType: 'BUSCAR_PLANES',
    effectiveDate: formValues.effectiveDate,
    year: getYearFromEffectiveDate(formValues.effectiveDate),
    householdIncome: householdIncome.toFixed(2),
    countyfips: formValues.countyFips,
    countyfipsName: '',
    state: getStateEUParseIdById(dataStates?.allStates, '' + formValues.stateEU?.id)?.code || '',
    zipCode: formValues.zipCode,
    market: 'Individual',
    limit: 10,
    offset: 0,
    order: 'asc',
    utilizationLevel: '',
    numberOfMembers: String(allMembers.length + 1),
    personOne: personOne,
    people,
  }
}
